module.exports = __webpack_public_path__ + "img/40_70_001_751.25ab99a5.jpg";